import { CATALOG, SCHEMA } from "constants/action-types";
import { mutateAsync } from "lib/api";
import { sortQuery, updateQuery } from "queries/catalog-entry";
import { activeListAdd } from "./active-list";

export const fetchEntries = (
    key: string,
    cacheKey,
    id,
    filters: { [key: string]: any },
    brand?: string,
    forceUpdate?: boolean,
    fromAssortment?: boolean
) => {
    return {
        payload: {
            id,
            filters,
            brand,
        },
        meta: {
            forceUpdate,
            key,
            cacheKey,
            fromAssortment,
        },
        type: CATALOG.ENTRIES.FETCH.START,
    };
};

export const fetchAllEntries = (id: string) => {
    return {
        payload: {
            id,
        },
        type: CATALOG.ENTRIES.ALL.FETCH.START,
    };
};

export const createDummySchema = (schema) => {
    return {
        payload: {
            schema,
        },
        type: SCHEMA.DUMMY.CREATE,
    };
};

export const fetchEntriesNextPage = (key: string, nextPage, fromAssortment?: boolean) => {
    return {
        meta: {
            key,
            nextPage,
            fromAssortment,
        },
        type: CATALOG.ENTRIES.FETCH.START,
    };
};

export const reorderEntries = (catalogId: string, { oldIndex, newIndex, index, item, type }) => {
    return {
        payload: { oldIndex, newIndex, index, item, type },
        meta: {
            catalogId,
        },
        type: CATALOG.ENTRIES.REORDER.START,
    };
};

// TODO: Remove Thunk
export const saveReorderEntries = (catalogId, { oldIndex, newIndex, item, type, items }) => {
    return (dispatch, getState) => {
        const state = getState();
        const { results } = state.entries.collections[catalogId];
        const entryId = results[newIndex];
        let before = results[newIndex - 1];
        if (newIndex === 0) {
            before = null;
        }

        // reorder or insert
        if (oldIndex !== -1) {
            dispatch(mutateAsync(sortQuery(catalogId, entryId, before)));
        } else {
            const entry = state.entities.entries && state.entities.entries[entryId];
            // check if active list
            if (item && state.activeList.current && results && state.activeList.current.id === catalogId) {
                dispatch(activeListAdd(item._id));
            }
            if (entry) {
                dispatch({
                    type: CATALOG.ENTRY.ADD.FETCH.START,
                    payload: {
                        catalogId,
                        item,
                        entry,
                        before,
                        index: newIndex,
                    },
                    meta: {
                        alreadyAdded: true,
                        type,
                    },
                });
            }
        }
    };
};

export const deleteEntry = (catalogId, entry) => ({
    payload: { entry },
    meta: {
        catalogId,
    },
    type: CATALOG.ENTRY.DELETE.START,
});
export const deleteSelectedEntries = (catalogId, query) => ({
    payload: { query },
    meta: {
        catalogId,
    },
    type: CATALOG.ENTRIES.DELETE.START,
});

export const updateEntry = (catalogId, entry, changes = {}) => {
    return (dispatch, getState) => {
        dispatch(mutateAsync(updateQuery(catalogId, entry.id, changes)));
    };
};

export const invalidateCacheKey = (catalogId) => ({
    payload: catalogId,
    type: CATALOG.ENTRIES.CACHE.INVALIDATE,
});

export const cancelFetchEntries = () => ({ type: CATALOG.ENTRIES.FETCH.CANCEL });

export const filtersRefreshStart = (catalogId) => {
    return {
        meta: {
            catalogId,
        },
        type: CATALOG.ENTRIES.FILTERS.REFRESH.START,
    };
};

export const filtersRefreshComplete = (catalogId) => {
    return {
        meta: {
            catalogId,
        },
        type: CATALOG.ENTRIES.FILTERS.REFRESH.COMPLETE,
    };
};
